// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"ce1b319b","294":"48fbb0ec","422":"bd39a9ee","485":"7f4a5eb3","577":"3c8fe011","591":"1062d0c5","691":"2357e72b","858":"25f81dba"}[chunkId] + ".chunk.js";
};